import React from 'react';
import styled from '@emotion/styled';
import { bluePlanetTheme } from 'ui/theme';

const StyledInput = styled.input`
  border: 0;
  outline: none;
  border-bottom: 1px solid ${bluePlanetTheme.bluePlanetPalette.indigo.main};
  max-width: 80px;

  /* Remove spinner arrows - Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Remove spinner arrows - Firefox */
  -moz-appearance: textfield;
`;

const NumberInput = (props: {
  autoFocus?: boolean;
  min?: number;
  max?: number;
  name: string;
  value: string | number;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}) => (
  <StyledInput
    type="number"
    {...props}
    onKeyDown={e => {
      if (e.ctrlKey || e.metaKey) return;

      const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
      if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
      }
    }}
    onPaste={e => {
      const paste = e.clipboardData.getData('text');
      if (!/^\d+$/.test(paste)) {
        e.preventDefault();
      }
    }}
  />
);

export default NumberInput;
